<template>
    <div>
        <keep-alive v-if="$route.meta.notCache">
            <router-view></router-view>
        </keep-alive>
        <router-view v-if="!$route.meta.notCache"></router-view>
        <edit-rules-modal></edit-rules-modal>
        <del-rules-modal></del-rules-modal>
        <rules-status></rules-status>
        <apply-safety-rule></apply-safety-rule>
        <import-rule></import-rule>
        <environment-settings></environment-settings>
        <move-safe-group></move-safe-group>
        <safe-group-manage></safe-group-manage>
    </div>
</template>

<script>
import editRulesModal from "./modals/editRulesModal";
import delRulesModal from "./modals/delRulesModal";
import rulesStatus from "./modals/rulesStatus";
import applySafetyRule from "./modals/applySafetyRule";
import importRule from "./modals/importRule";
import environmentSettings from "./modals/environmentSettings";
import moveSafeGroup from "./modals/moveSafeGroup";
import safeGroupManage from "./modals/safeGroupManage";
import { mapActions } from "vuex";
export default {
    name: "securityCenter",
    components: {
        editRulesModal,
        delRulesModal,
        rulesStatus,
        applySafetyRule,
        importRule,
        environmentSettings,
        moveSafeGroup,
        safeGroupManage
    },
    beforeRouteEnter(to, from, next) {
        next(vm => {
            vm.getListInfo();
        });
    },
    methods: {
        ...mapActions([
            "securityCenter/actionSetSecurityInfo"
        ]),
        async getListInfo() {
            this["securityCenter/actionSetSecurityInfo"]();
        }
    }
};
</script>

<style lang="scss" scoped></style>
